import { WORSEN_AFTER_MS } from './health.js';
/** Sounds while the call is cut off, round after round until it is back (then a short "connected"). */
export function createReconnectAlarm({ cue, reconnected, delayMs = WORSEN_AFTER_MS, repeatMs = 2_000 }) {
    let waiting;
    let repeating;
    let sounding = false;
    function silence() {
        clearTimeout(waiting);
        clearInterval(repeating);
        waiting = undefined;
        repeating = undefined;
        const was = sounding;
        sounding = false;
        return was;
    }
    return {
        update(link) {
            if (link === 'dropped') {
                if (waiting !== undefined || sounding)
                    return;
                waiting = setTimeout(() => {
                    waiting = undefined;
                    sounding = true;
                    cue();
                    repeating = setInterval(cue, repeatMs);
                }, delayMs);
                return;
            }
            if (silence() && link === 'ok')
                reconnected();
        },
        /** Whether it is sounding now. */
        get sounding() {
            return sounding;
        },
    };
}
/** The call's state as the alarm needs it. */
export function callLink(state) {
    if (!state.room || state.deafened)
        return 'gone';
    return state.connection === 'reconnecting' || state.quality === 'lost' ? 'dropped' : 'ok';
}
//# sourceMappingURL=reconnect.js.map